import React, { FC } from 'react';
import { CartModelDisplayProvider } from '../../context/CartModelDisplayContext';
import CartConfigurator from '../../components/CartConfigurator/CartConfigurator';

interface CartConfiguratorPageProps { }

const CartConfiguratorPage: FC<CartConfiguratorPageProps> = () => (
  <CartModelDisplayProvider>
    <CartConfigurator hideAllPrices={process.env.REACT_APP_CART_CONFIGURATOR_SHOW_PRICE !== 'true'} />
  </CartModelDisplayProvider>
);

export default CartConfiguratorPage;
 